import { atomWithStorage } from 'jotai/utils';
import {
  SUPPORTED_LOCALES,
  DEFAULT_LOCALE,
  LOCALE_STORAGE_KEY,
  readInitialLocale
} from '../translate/polyglot-registry';

export const localeAtom = atomWithStorage(LOCALE_STORAGE_KEY, readInitialLocale());

// `country` is the ISO-3166 code used by the country-flag-icons CDN
// (already in use across stateful/knowledge-base/etc.).
// Note: `fil` = Filipino, the standardized form of Tagalog. The labels say
// Tagalog because most consumers of this locale think of it as Tagalog;
// the locale code stays `fil` (ISO 639-2 for Filipino).
export const LOCALE_META = {
  en: { code: 'en', label: 'English', nativeLabel: 'English', country: 'US', dir: 'ltr', htmlLang: 'en' },
  es: { code: 'es', label: 'Spanish', nativeLabel: 'Español', country: 'ES', dir: 'ltr', htmlLang: 'es' },
  fil: { code: 'fil', label: 'Tagalog', nativeLabel: 'Tagalog', country: 'PH', dir: 'ltr', htmlLang: 'fil' },
  ja: { code: 'ja', label: 'Japanese', nativeLabel: '日本語', country: 'JP', dir: 'ltr', htmlLang: 'ja' },
  th: { code: 'th', label: 'Thai', nativeLabel: 'ไทย', country: 'TH', dir: 'ltr', htmlLang: 'th' }
};

export { SUPPORTED_LOCALES, DEFAULT_LOCALE };
